import {isValid} from 'validators/number-validator';

export const getLowestValueAboveZero = (values) => {
  const cleaned = values
    // Clean out any invalid indexes:
    .filter((value) => isValid(value))
    // Clean out any zeroes or minus numbers:
    .filter((value) => value > 0);

  // If nothing above 0, return null
  if (!cleaned.length) {
    return null;
  }

  return (
    cleaned
      // Reduce to lowest value:
      .reduce((previous, current) => Math.min(previous, current))
  );
};

export const getMid = (value1, value2) => {
  if (isValid(value1) && isValid(value2) && value2 > value1) {
    return (value1 + value2) / 2;
  }
  return NaN;
};

export const getValueAboveZero = (value) => {
  return value > 0 ? value : 0;
};
